import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react'

export const useDebounce = <Value = unknown>(
  initialValue: Value,
  delayMilliseconds = 200
): [Value, Dispatch<SetStateAction<Value>>, Value] => {
  const [value, setValue] = useState(initialValue)
  const [debounced, setDebounced] = useState<Value>(initialValue)

  const timerRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    if (timerRef.current !== null) {
      clearTimeout(timerRef.current)

      timerRef.current = null
    }

    timerRef.current = setTimeout(() => {
      setDebounced(value)
    }, delayMilliseconds)

    return () => {
      if (timerRef.current !== null) {
        clearTimeout(timerRef.current)
      }
    }
  }, [value])

  return [debounced, setValue, value]
}
